// @core/api/endpoints/calendar/resolve_calendar_context.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ResolveCalendarContextRequest,
  ResolveCalendarContextResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Resolve calendar context
 * Resolves the effective calendar policy for a scope entity by merging the policy hierarchy. Returns merged policy, available templates, and allowed event types.
 */
export async function ResolveCalendarContext(
  data: ResolveCalendarContextRequest,
  options?: RequestOptions
): Promise<ResolveCalendarContextResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/calendar/resolve-context`;
  const requestOptions = options;
  return client.post<ResolveCalendarContextResponse>(requestPath, data, requestOptions);
}
